import React, { useState } from "react";
import { Box, Typography, ClickAwayListener, Container } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useNavigate } from "react-router-dom";
import { useAppConfig } from "../../context/AppConfigContext";

const NavMenuDesktop = () => {
  const { config } = useAppConfig();
  const navConfig = config?.navigation || [];

  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();

  const handleToggle = (label) => {
    setOpenDropdown((prev) => (prev === label ? null : label));
  };

  const handleClickAway = () => {
    setOpenDropdown(null);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 3,
        }}>
        {navConfig.map((section) => {
          const activeGroups =
            section.groups?.filter((g) => g.items?.some((i) => i.isActive)) ||
            [];

          return (
            <Box key={section.label}>
              <Box
                onClick={() => handleToggle(section.label)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: "pointer",
                  color: "#1A1A1A",
                  fontWeight: 500,
                  "&:hover": { color: "#FD7762" },
                }}>
                <Typography sx={{ fontSize: "1.15rem" }}>
                  {section.label}
                </Typography>
                {openDropdown === section.label ? (
                  <KeyboardArrowUpIcon fontSize="small" />
                ) : (
                  <KeyboardArrowDownIcon fontSize="small" />
                )}
              </Box>

              {openDropdown === section.label && (
                <Container
                  maxWidth="xl"
                  disableGutters
                  sx={{
                    position: "absolute",
                    top: "calc(100% - 1px)",
                    left: 0,
                    right: 0,
                    zIndex: 1300,
                    bgcolor: "white",
                    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.05)",
                    py: 3,
                    px: 0,
                    opacity: 0,
                    animation: "fadeInDropdown 200ms ease-out forwards",
                    "@keyframes fadeInDropdown": {
                      from: { opacity: 0, transform: "translateY(-4px)" },
                      to: { opacity: 1, transform: "translateY(0)" },
                    },
                  }}>
                  {section.label === "Services" ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 4,
                      }}>
                      {activeGroups.map((group) => {
                        const item = group.items[0];
                        return (
                          <Box
                            key={group.label}
                            onClick={() => {
                              if (item.isActive && !group.showAsComingSoon) {
                                navigate(item.path);
                                setOpenDropdown(null);
                              }
                            }}
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center",
                              px: 2,
                              cursor:
                                item.isActive && !group.showAsComingSoon
                                  ? "pointer"
                                  : "default",
                              "&:hover img": {
                                opacity:
                                  item.isActive && !group.showAsComingSoon
                                    ? 0.9
                                    : 1,
                              },
                              "&:hover .title": {
                                color:
                                  item.isActive && !group.showAsComingSoon
                                    ? "#FD7762"
                                    : "#1A1A1A",
                              },
                            }}>
                            <Box
                              component="img"
                              src={item.coverImgPath}
                              alt={item.label}
                              sx={{
                                width: "100%",
                                maxWidth: 250,
                                height: 150,
                                borderRadius: 3,
                                objectFit: "cover",
                                mb: 1,
                                transition: "opacity 0.2s",
                              }}
                            />

                            <Typography
                              className="title"
                              variant="subtitle2"
                              sx={{
                                fontWeight: 700,
                                mb: 0.5,
                                color: "#1A1A1A",
                                textTransform: "uppercase",
                                transition: "color 0.2s",
                              }}>
                              {group.label}
                            </Typography>

                            {group.showAsComingSoon && (
                              <Box
                                sx={{
                                  fontSize: "0.75rem",
                                  px: 1.5,
                                  py: 0.3,
                                  borderRadius: 99,
                                  backgroundColor: "#F4CF41",
                                  display: "inline-block",
                                  mt: 0.5,
                                }}>
                                coming soon
                              </Box>
                            )}

                            {!group.showAsComingSoon && group.newLaunch && (
                              <Box
                                sx={{
                                  fontSize: "0.75rem",
                                  px: 1.5,
                                  py: 0.3,
                                  borderRadius: 99,
                                  backgroundColor: "#C3F584",
                                  display: "inline-block",
                                  mt: 0.5,
                                  fontWeight: 500,
                                  color: "#1A1A1A",
                                }}>
                                New Launch
                              </Box>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 4,
                      }}>
                      {activeGroups.map((group) => (
                        <Box key={group.label} sx={{ flex: 1, px: 2 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 700,
                              mb: 1,
                              color: "#1A1A1A",
                              textTransform: "uppercase",
                            }}>
                            {group.label}
                          </Typography>

                          {group.items
                            .filter((item) => item.isActive)
                            .map((item) => (
                              <Typography
                                key={item.label}
                                onClick={() => {
                                  navigate(item.path);
                                  setOpenDropdown(null);
                                }}
                                sx={{
                                  cursor: "pointer",
                                  color: "#515151",
                                  py: 0.75,
                                  fontSize: "0.95rem",
                                  "&:hover": { color: "#FD7762" },
                                }}>
                                {item.label}
                              </Typography>
                            ))}

                          {group.items.filter((item) => item.isActive)
                            .length === 0 && (
                            <Box
                              sx={{
                                fontSize: "0.75rem",
                                px: 1.5,
                                py: 0.3,
                                borderRadius: 99,
                                backgroundColor: "#F4CF41",
                                display: "inline-block",
                                mt: 0.5,
                              }}>
                              coming soon
                            </Box>
                          )}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Container>
              )}
            </Box>
          );
        })}

        {/* <Typography
            onClick={() => navigate("/about")}
            sx={{
              cursor: "pointer",
              color: "#1A1A1A",
              fontSize: "1.15rem",
              "&:hover": { color: "#FD7762" },
            }}>
            About
          </Typography> */}
      </Box>
    </ClickAwayListener>
  );
};

export default NavMenuDesktop;
